<template>
    <!--上岗申请 -->
    <vxe-modal
        v-model="formInput.isShow"
        @close="closeWinEvent"
        :title="formInput.title"
        width="840"
        height="600"
        show-zoom
        resize
        remember
        show-footer
    >
        <template #default>
            <vxe-form
                :data="formInput.formData"
                :rules="formInput.formRules"
                title-align="right"
                ref="rForm"
                title-width="60"
            >
                <vxe-form-item
                    title="基本信息"
                    span="24"
                    title-align="left"
                    title-width="200px"
                    :title-prefix="{ icon: 'fa fa-address-card-o' }"
                ></vxe-form-item>
                <vxe-form-item
                    title="开发编号"
                    field="ProcessID"
                    span="10"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.ProcessID"
                            placeholder="请选择开发编号"
                            :disabled="formInput.allInputDisable"
                            readonly
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item span="2">
                    <template #default>
                        <vxe-button
                            @click="selectReqs()"
                            :disabled="formInput.allInputDisable"
                            >选择
                        </vxe-button>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="数字员工名称"
                    field="ProcessName"
                    span="12"
                    title-width="130px"
                    :title-prefix="{
                        content: '允许使用中文、英文、数字和_（）()【】[]-、',
                        icon: 'vxe-icon-question-circle-fill',
                    }"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.ProcessName"
                            placeholder="请填写课题名称，非个人姓名或工号"
                            :disabled="formInput.allInputDisable"
                            :readonly="proxy.$store.state.isAdmin == '0'"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="工作场景描述"
                    field="processDesc"
                    span="24"
                    title-width="120px"
                >
                    <vxe-textarea
                        v-model="formInput.formData.processDesc"
                        placeholder="填写（流程、痛点、解决方案）"
                        maxlength="500"
                        show-word-count
                        :disabled="formInput.allInputDisable"
                    ></vxe-textarea>
                </vxe-form-item>
                <vxe-form-item
                    title="场景业务价值"
                    field="sceneBussValue"
                    span="24"
                    title-width="120px"
                >
                    <vxe-textarea
                        v-model="formInput.formData.sceneBussValue"
                        placeholder="填写（体验、收益、效率、效果）"
                        maxlength="500"
                        show-word-count
                        :disabled="formInput.allInputDisable"
                    ></vxe-textarea>
                </vxe-form-item>

                <vxe-form-item
                    title="申请人(孵化者)"
                    field="CreateManName"
                    span="10"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.CreateManName"
                            placeholder="请输入姓名"
                            readonly
                            :disabled="formInput.allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item span="2">
                    <template #default>
                        <vxe-button
                            @click="selectUser(1)"
                            :disabled="
                                proxy.$store.state.isAdmin == '0' ||
                                formInput.allInputDisable
                            "
                            >选择</vxe-button
                        >
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="总部"
                    field="division"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.division"
                            placeholder="请输入总部"
                            readonly
                            :disabled="formInput.allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="数字员工类型"
                    field="empType"
                    span="10"
                    :title-prefix="{
                        content:
                            '作业型：基于RPA/Python技术搭建的自动化流程\n助手型：基于Dify，或有调用大模型的AI应用\n专家型：使用算法、自建模型搭建的AI应用',
                        icon: 'vxe-icon-question-circle-fill',
                    }"
                    title-width="130px"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.empType"
                            :options="formInput.digitalTypes"
                            placeholder="请选择数字员工类型"
                            :disabled="formInput.allInputDisable"
                            @change="onEmpTypeChange"
                        >
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                    <a
                        href="https://coe.dongfeng-nissan.com.cn/admin/forum/postsPage/postsContent?searcharticle=1727"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        说明
                    </a>
                </vxe-form-item>
                <vxe-form-item
                    title="数字员工简介"
                    field="introduction"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.introduction"
                            clearable
                            placeholder="请输入数字员工简介"
                            :disabled="formInput.allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="辅导老师"
                    field="techUID"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.techUID"
                            :options="formInput.allTechs"
                            placeholder="请选择辅导老师"
                            :disabled="formInput.allInputDisable"
                        >
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="场景组担当"
                    field="sceneUID"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.sceneUID"
                            :options="formInput.allScenes"
                            placeholder="请选择场景组担当"
                            :disabled="true"
                        >
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="业务人员"
                    field="UserNameEmail"
                    span="10"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.UserNameEmail"
                            readonly
                            placeholder="请选择业务人员"
                            :disabled="formInput.allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item span="2">
                    <template #default>
                        <vxe-button
                            @click="selectUser(2)"
                            :disabled="formInput.allInputDisable"
                            >选择</vxe-button
                        >
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="发布阶段"
                    field="PubState"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            v-model="formInput.formData.PubState"
                            @change="onSelectPubState('2')"
                            placeholder="请选择发布阶段"
                            :disabled="formInput.allInputDisable"
                            clearable
                        >
                            <vxe-option value="1" label="测试发布"></vxe-option>
                            <vxe-option value="2" label="生产发布"></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="部署平台"
                    field="realPlatform"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.realPlatform"
                            :options="formInput.planPlatform"
                            placeholder="请选择实际部署平台"
                            readonly
                            :disabled="formInput.allInputDisable"
                            @change="onSelectPubState"
                        >
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    :title="otherPlatformLabel"
                    field="otherPlatform"
                    span="12"
                    title-width="130px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.otherPlatform"
                            clearable
                            :placeholder="otherPlatformLabel"
                            :disabled="formInput.allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="外部AppID"
                    field="otherAppID"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.otherAppID"
                            clearable
                            placeholder="请输入外部AppID.例如Dify应用ID"
                            title="AppId将关联使用量统计，如不清楚如何获取请咨询辅导老师!"
                            :disabled="formInput.allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="数字员工版本"
                    field="empVersion"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.empVersion"
                            clearable
                            placeholder="请输入数字员工版本.例如：V1.0"
                            :disabled="formInput.allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    :visible="isDifyDE"
                    title="公开范围"
                    field="difyViewType"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            v-model="formInput.formData.difyViewType"
                            placeholder="请选择发公开范围"
                            :disabled="formInput.allInputDisable"
                            empty-value=""
                            @change="onDifyViewTypeChange"
                            @clear="formInput.formData.difyViewType = ''"
                        >
                            <vxe-option value="1" label="个人"></vxe-option>
                            <vxe-option value="2" label="总部"></vxe-option>
                            <vxe-option value="3" label="全部"></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    :visible="isDifyDE"
                    title="公开总部"
                    field="difyViewDivsion"
                    span="12"
                    title-width="120px"
                >
                    <template #default>
                        <vxe-select
                            v-model="formInput.formData.difyViewDivsion"
                            placeholder="请选择公开总部"
                            :disabled="formInput.allInputDisable"
                            clearable
                            multiple
                            empty-value=""
                            @clear="formInput.formData.difyViewDivsion = ''"
                            :options="formInput.hqOptions"
                        >
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="运行方式"
                    field="deployType"
                    span="12"
                    title-width="120px"
                    :title-prefix="{
                        content:
                            '平台：程序运行在服务器端，可在本网站直接触发或跳转执行（如派神易、UiPath、Python、Dify）\n本地：程序运行在个人电脑上（如本地 Python、VBA 脚本等），无法通过本网站触发执行，Out System 等外部系统需选择本地',
                        icon: 'vxe-icon-question-circle-fill',
                    }"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.deployType"
                            placeholder="请选择运行方式"
                            :disabled="formInput.allInputDisable"
                            @change="onSelectDeployType"
                        >
                            <vxe-option value="平台" label="平台"></vxe-option>
                            <vxe-option value="本地" label="本地"></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="版本变更备注"
                    field="verHistory"
                    span="12"
                    title-width="120px"
                    v-if="false"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.verHistory"
                            clearable
                            placeholder="请输入版本变更备注"
                            :disabled="formInput.allInputDisable"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="本地运行原因"
                    field="localReason"
                    span="24"
                    title-width="120px"
                    :visible="isShowDeployType"
                >
                    <template #default>
                        <vxe-textarea
                            v-model="formInput.formData.localReason"
                            placeholder="请输入本地运行原因"
                            maxlength="1000"
                            show-word-count
                            :disabled="formInput.allInputDisable"
                        ></vxe-textarea>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="本地程序类型"
                    field="localAppType"
                    span="12"
                    title-width="120px"
                    :visible="isShowDeployType"
                >
                    <template #default>
                        <vxe-select
                            transfer
                            v-model="formInput.formData.localAppType"
                            placeholder="请选择本地程序类型"
                            :disabled="formInput.allInputDisable"
                            @change="onSelectLocalAppType"
                        >
                            <vxe-option
                                v-for="option in localAppTypeOptions"
                                :key="option.value"
                                :value="option.value"
                                :label="option.label"
                            ></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title=""
                    span="4"
                    :item-render="{}"
                    :visible="isShowDeployType && isShowLocalAppPath"
                >
                    <template #default="">
                        <vxe-button
                            :disabled="formInput.allInputDisable"
                            @click="generateBatEntry"
                            icon="fa fa-file"
                            >生成注册文件</vxe-button
                        >
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title=""
                    span="4"
                    :item-render="{}"
                    :visible="isShowDeployType && isShowLocalAppPath"
                >
                    <template #default="">
                        <vxe-button
                            style="margin-left: 10px"
                            :disabled="formInput.allInputDisable"
                            @click="execLocalFile"
                            icon="fa fa-play"
                            >测试执行</vxe-button
                        >
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title=""
                    span="4"
                    :item-render="{}"
                    :visible="isShowDeployType && isShowLocalAppPath"
                >
                    <a href="javascript:void(0);" @click="viewInstructions"
                        >填写说明</a
                    >
                </vxe-form-item>
                <vxe-form-item
                    title=""
                    span="12"
                    :item-render="{}"
                    :visible="
                        ['4', '5', '6', '7', '8'].includes(
                            formInput.formData.localAppType
                        ) && isShowDeployType
                    "
                >
                    <span style="color: red">
                        {{
                            getLocalAppTypeTip(formInput.formData.localAppType)
                        }}
                    </span>
                </vxe-form-item>

                <vxe-form-item
                    :title="localAppPathLabel"
                    field="localAppPath"
                    span="22"
                    title-width="120px"
                    :visible="isShowDeployType && isShowLocalAppPath"
                >
                    <template #default="{ data }">
                        <vxe-input
                            v-model="data.localAppPath"
                            :placeholder="localAppPlaceholder"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title=""
                    span="2"
                    :item-render="{}"
                    :visible="isShowDeployType && isShowLocalAppPath"
                >
                    <template #default=""> </template>
                </vxe-form-item>
                <vxe-form-item
                    :title="localExeFileLabel"
                    field="localExeFile"
                    span="22"
                    title-width="120px"
                    :visible="isShowDeployType && isShowLocalExeFile"
                >
                    <template #default="{ data }">
                        <vxe-input
                            v-model="data.localExeFile"
                            :placeholder="localFilePlaceholder"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title=""
                    span="2"
                    :item-render="{}"
                    :visible="isShowDeployType && isShowLocalExeFile"
                >
                    <template #default=""> </template>
                </vxe-form-item>
                <vxe-form-item
                    :title="localExeParamLabel"
                    field="localExeParam"
                    span="22"
                    title-width="120px"
                    :visible="isShowDeployType && isShowLocalExeParam"
                >
                    <template #default="{ data }">
                        <vxe-input
                            v-model="data.localExeParam"
                            placeholder="请输入程序参数"
                        ></vxe-input>
                    </template>
                </vxe-form-item>

                <vxe-form-item
                    title="生产发布填写"
                    span="24"
                    title-align="left"
                    title-width="200px"
                ></vxe-form-item>

                <vxe-form-item
                    title="Before-人工每次耗时(分钟)"
                    field="ManSingleTime"
                    :title-prefix="{
                        content:
                            '人工每次执行的耗时（仅限于数字员工执行任务的部分）,请谨慎填写，该字段直接影响该数字员工的等效工时',
                        icon: 'vxe-icon-question-circle-fill',
                    }"
                    span="12"
                    title-width="220px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            clearable
                            v-model="formInput.formData.ManSingleTime"
                            placeholder="请输入Before-人工每次耗时(分钟)"
                            @change="updateSingleSaveTime"
                            :disabled="
                                !formInput.formData.isPro ||
                                formInput.allInputDisable ||
                                formInput.allInputDisable
                            "
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="Before-人工每月次数"
                    field="ManFrequency"
                    :title-prefix="{
                        content: '人工每月执行次数（未实现数字员工前）',
                        icon: 'vxe-icon-question-circle-fill',
                    }"
                    span="12"
                    title-width="200px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            clearable
                            v-model="formInput.formData.ManFrequency"
                            placeholder="请输入Before-人工每月次数"
                            :disabled="
                                !formInput.formData.isPro ||
                                formInput.allInputDisable
                            "
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="After-每次耗时(分钟)"
                    field="RobotSingleTime"
                    :title-prefix="{
                        content: '数字员工单次执行任务的耗时',
                        icon: 'vxe-icon-question-circle-fill',
                    }"
                    span="12"
                    title-width="220px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            clearable
                            v-model="formInput.formData.RobotSingleTime"
                            placeholder="请输入After-每次耗时(分钟)"
                            @change="updateSingleSaveTime"
                            :disabled="
                                !formInput.formData.isPro ||
                                formInput.allInputDisable
                            "
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="After-每月次数"
                    field="RobotMonthRun"
                    :title-prefix="{
                        content:
                            '数字员工每月计划执行次数（含定时任务、接口调用、人工驱动等）',
                        icon: 'vxe-icon-question-circle-fill',
                    }"
                    span="12"
                    title-width="200px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            clearable
                            v-model="formInput.formData.RobotMonthRun"
                            placeholder="请输入After-每月次数"
                            :disabled="
                                !formInput.formData.isPro ||
                                formInput.allInputDisable
                            "
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="单次节省-时间(分钟)"
                    field="SingleSaveTime"
                    :title-prefix="{
                        content: '自动计算，人工单次耗时-数字员工单次耗时',
                        icon: 'vxe-icon-question-circle-fill',
                    }"
                    span="12"
                    title-width="220px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            clearable
                            v-model="formInput.formData.SingleSaveTime"
                            placeholder="请输入单次节省-时间(分钟)"
                            disabled
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="开发时长(小时)"
                    field="DevelopTime"
                    span="12"
                    title-width="200px"
                >
                    <template #default>
                        <vxe-input
                            type="number"
                            clearable
                            v-model="formInput.formData.DevelopTime"
                            placeholder="请输入数字员工开发时间"
                            :disabled="
                                !formInput.formData.isPro ||
                                formInput.allInputDisable
                            "
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="定时执行时间"
                    field="ExecBegin"
                    span="12"
                    title-width="220px"
                    :title-prefix="{
                        content:
                            '在固定的时间点启动该数字员工，如填写：每周一至周五早上8点/每个月1号的下午两点',
                        icon: 'vxe-icon-question-circle-fill',
                    }"
                >
                    <template #default>
                        <vxe-input
                            type="text"
                            clearable
                            v-model="formInput.formData.ExecBegin"
                            placeholder="例:每日08:30"
                            :disabled="
                                !formInput.formData.isPro ||
                                formInput.allInputDisable
                            "
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="-"
                    field="ExecEnd"
                    span="6"
                    title-width="30px"
                >
                    <template #default>
                        <vxe-input
                            type="text"
                            clearable
                            v-model="formInput.formData.ExecEnd"
                            placeholder="例:每日17:30"
                            :disabled="
                                !formInput.formData.isPro ||
                                formInput.allInputDisable
                            "
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="总任务节点数"
                    field="operationNodes"
                    span="12"
                    title-width="220px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.operationNodes"
                            type="number"
                            min="0"
                            clearable
                            placeholder="请输入总任务节点数"
                            :disabled="
                                !formInput.formData.isPro ||
                                formInput.allInputDisable
                            "
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="数字员工替代节点数"
                    field="replaceNodes"
                    span="10"
                    title-width="200px"
                >
                    <template #default>
                        <vxe-input
                            v-model="formInput.formData.replaceNodes"
                            type="number"
                            min="0"
                            clearable
                            placeholder="请输入数字员工替代节点数"
                            :disabled="
                                !formInput.formData.isPro ||
                                formInput.allInputDisable
                            "
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                    <a
                        href="https://coe.dongfeng-nissan.com.cn/admin/forum/postsPage/postsContent?searcharticle=1737"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        说明
                    </a>
                </vxe-form-item>
                <vxe-form-item
                    title="等效工时计算公式"
                    field=""
                    color="red"
                    span="24"
                    title-width="220px"
                >
                    <div style="color: red">
                        平台运行：实际运行成功次数 * Before-人工每次耗时<br />
                        本地运行：After-每月次数 * Before-人工每次耗时
                    </div>
                </vxe-form-item>
                <vxe-form-item
                    title="附件"
                    span="24"
                    title-align="left"
                    title-width="200px"
                    :title-prefix="{ icon: 'fa fa-paperclip' }"
                ></vxe-form-item>
                <vxe-form-item
                    title="程序包"
                    field="fPathPackage"
                    span="18"
                    :item-render="{}"
                    title-width="120px"
                >
                    <template #default="{ data }">
                        <vxe-input
                            v-model="data.fPathPackage"
                            placeholder="请选择程序包"
                            readonly
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                    <template #default="">
                        <vxe-button
                            :disabled="formInput.allInputDisable"
                            @click="insertPackageEvent"
                            >浏览</vxe-button
                        >
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                    <a
                        v-if="isShowPackageLink"
                        href="javascript:void(0);"
                        @click="downloadFile(1)"
                        >下载</a
                    >
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                    <a
                        href="https://coe.dongfeng-nissan.com.cn/admin/forum/postsPage/postsContent?searcharticle=1736"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        说明
                    </a>
                </vxe-form-item>
                <vxe-form-item
                    title="设计文档"
                    field="fPathPdd"
                    span="18"
                    :item-render="{}"
                    title-width="120px"
                >
                    <template #default="{ data }">
                        <vxe-input
                            v-model="data.fPathPdd"
                            placeholder="请选择设计文档"
                            readonly
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                    <template #default="">
                        <vxe-button
                            :disabled="formInput.allInputDisable"
                            @click="insertPDDEvent"
                            >浏览</vxe-button
                        >
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                    <a
                        v-if="isShowPDDLink"
                        href="javascript:void(0);"
                        @click="downloadFile(2)"
                        >下载</a
                    >
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                    <a
                        v-if="!isShowPDDLink"
                        href="javascript:void(0);"
                        @click="downloadFile(4)"
                        >模板</a
                    >
                </vxe-form-item>
                <vxe-form-item
                    title="数字员工照片"
                    field="fPathPhoto"
                    span="18"
                    :item-render="{}"
                    title-width="120px"
                >
                    <template #default="{ data }">
                        <vxe-input
                            v-model="data.fPathPhoto"
                            placeholder="请选择数字员工照片"
                            readonly
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                    <template #default="">
                        <vxe-button
                            @click="insertPhotoEvent"
                            :disabled="
                                !formInput.formData.isPro ||
                                formInput.allInputDisable
                            "
                        >
                            浏览
                        </vxe-button>
                    </template>
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                    <a
                        v-if="isShowPhotoLink"
                        href="javascript:void(0);"
                        @click="downloadFile(6)"
                        >下载</a
                    >
                </vxe-form-item>
                <vxe-form-item title="" span="2" :item-render="{}">
                </vxe-form-item>
                <vxe-form-item
                    span="24"
                    title-align="left"
                    title-width="600px"
                    :title-prefix="{ icon: 'fa fa-check-circle-o' }"
                    v-if="formInput.formData.AuditStatus == '1'"
                >
                    <template #title>
                        <span style="color: red">审核意见</span>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                    title="虚拟机"
                    field="MachineName"
                    span="12"
                    title-width="100px"
                    v-if="formInput.formData.AuditStatus == '1'"
                >
                    <template #default>
                        <vxe-select
                            v-model="formInput.formData.MachineName"
                            :options="toolbar.macOptions"
                            placeholder="请选择虚拟机"
                            clearable
                            :disabled="formInput.allInputDisable"
                        >
                        </vxe-select>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </template>
        <template #footer v-if="isViewFooter">
            <div style="text-align: center; width: 100%">
                <vxe-button
                    :loading="submitting"
                    @click="save"
                    icon="fa fa-save"
                    status="success"
                    >保存
                </vxe-button>
                <vxe-button
                    :loading="submitting"
                    @click="submit"
                    icon="fa fa-check"
                    status="primary"
                    >提交
                </vxe-button>
            </div>
        </template>
    </vxe-modal>
    <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
        <template #default>
            <div>
                <vxe-form :data="userTablePager">
                    <vxe-form-item
                        title="关键字"
                        field="searchKey"
                        :item-render="{}"
                    >
                        <template #default="{ data }">
                            <vxe-input
                                v-model="data.searchKey"
                                placeholder="请输入姓名或邮箱"
                                clearable
                            ></vxe-input>
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                @click="findUserData"
                                @keyup.enter="findUserData"
                                >查询</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                status="primary"
                                @click="confirmSelectUser"
                                >确定</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                    <vxe-form-item span="24">
                        <template #title>
                            <span>已选(</span
                            ><span style="color: red">双击选择</span
                            ><span>)</span>
                        </template>
                        <template #default>
                            <div v-if="formInput.userSelType == 1">
                                <template
                                    v-for="(item, index) in formInput.formData
                                        .DevelopIDName"
                                    :key="index"
                                >
                                    <span>{{ item.Name }}</span>
                                </template>
                            </div>
                            <div v-else-if="formInput.userSelType == 2">
                                <template
                                    v-for="(item, index) in formInput.formData
                                        .UserIDName"
                                    :key="index"
                                >
                                    <span>{{ item.Name }}</span>
                                    <va-icon
                                        class="icon-left input-icon"
                                        @click="clearUser(item.ID)"
                                        name="clear"
                                    />
                                </template>
                            </div>
                        </template>
                    </vxe-form-item>
                </vxe-form>
            </div>
            <div>
                <vxe-table
                    class="mytable-scrollbar"
                    :data="dtUser"
                    ref="xTableUser"
                    height="300"
                    @cell-dblclick="chooseUser"
                    highlight-hover-row
                    highlight-current-row
                >
                    <vxe-column
                        type="seq"
                        field="Uid"
                        title="序号"
                        width="50"
                    ></vxe-column>
                    <vxe-column
                        field="UserName"
                        title="姓名"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="JobZb"
                        title="总部"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="JobName"
                        title="部门"
                        width="120"
                        show-overflow
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="UserMail"
                        title="邮箱"
                        width="200"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="Id"
                        title="Id"
                        width="10"
                        :visible="false"
                    ></vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager
                    background
                    v-model:current-page="userTablePager.currentPage"
                    v-model:page-size="userTablePager.pageSize"
                    :total="userTablePager.totalResult"
                    @page-change="userListPageChange"
                    size="small"
                >
                </vxe-pager>
            </div>
        </template>
    </vxe-modal>
    <vxe-modal title="选择需求" v-model="isShowRequireSel" width="640">
        <template #default>
            <div>
                <vxe-form :data="reqTablePager">
                    <vxe-form-item
                        title="关键字"
                        field="searchKey"
                        :item-render="{}"
                    >
                        <template #default="{ data }">
                            <vxe-input
                                v-model="data.searchKey"
                                placeholder="请输入需求编号、开发编号、数字员工名称"
                                clearable
                            ></vxe-input>
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                @click="findReqsData"
                                @keyup.enter="findReqsData"
                                >查询</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                status="primary"
                                @click="confirmSelectReq"
                                >选择</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                </vxe-form>
            </div>
            <div>
                <vxe-table
                    class="mytable-scrollbar"
                    :data="dtReqs"
                    ref="xTableReqs"
                    height="300"
                    @cell-dblclick="confirmSelectReq"
                    highlight-hover-row
                    highlight-current-row
                >
                    <vxe-column
                        type="seq"
                        field="Id"
                        title="序号"
                        width="50"
                    ></vxe-column>
                    <vxe-column
                        field="requireNo"
                        title="需求编号"
                        width="140"
                        sortable
                        show-overflow
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="processName"
                        title="数字员工名称"
                        width="180"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="processID"
                        title="开发编号"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="processDesc"
                        title="工作场景描述"
                        width="200"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="bussName"
                        title="业务姓名"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="divison"
                        title="总部"
                        width="100"
                        sortable
                        show-overflow
                    ></vxe-column>
                    <vxe-column
                        field="dept"
                        title="业务部门"
                        width="120"
                        resizable
                        sortable
                        show-overflow
                    ></vxe-column>
                    <vxe-column
                        field="office"
                        title="业务科室"
                        width="120"
                        sortable
                        show-overflow
                    ></vxe-column>
                    <vxe-column
                        field="winMan"
                        title="业务窗口"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="leader"
                        title="业务科长"
                        width="100"
                        sortable
                    ></vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager
                    background
                    v-model:current-page="reqTablePager.currentPage"
                    v-model:page-size="reqTablePager.pageSize"
                    :total="reqTablePager.totalResult"
                    @page-change="reqListPageChange"
                    size="small"
                >
                </vxe-pager>
            </div>
        </template>
    </vxe-modal>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    getCurrentInstance,
    defineExpose,
    defineEmits,
} from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";
const { proxy } = getCurrentInstance();
const packageForm = reactive({
    dtPackage: [],
    realPlatform: "", //部署平台
    iShow: false, //显示更新包
    packageFile: {}, //更新包附件
    packageName: "",
    uploadTimes: 0, //可以上传次数
    selPublishId: "", //更新的ID
    isDisable: false,
});
const toolbar = reactive({
    loading: false,
    macOptions: [],
    allStatus: [],
    allReqPlatform: [],
    formData: {
        selectMac: "",
        status: "",
        pubstatus: "",
        searchKey: "",
        dept: "",
        realPlatform: "",
        reqPlatform: "",
    },
});
const userTablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
    searchKey: "",
});
const formInput = reactive({
    title: "新增上岗申请",
    isShow: false,
    saveButDisable: false,
    allInputDisable: false,
    processIDReadonly: true,
    userSelType: 2, //1 开发人员 2 业务人员
    allTechs: [], //技术组担当
    allScenes: [], //场景组担当
    planPlatform: [], //部署平台
    digitalTypes: [], //员工类型
    hqOptions: [],
    sceneUID: "",
    formData: {
        Id: "",
        empNo: "",
        AuditStatus: "0",
        reqNo: "", //需求编号
        ProcessName: "",
        ProcessID: "",
        processDesc: "",
        sceneBussValue: "",
        CreateMan: "",
        CreateManName: "",
        division: "",
        empType: "",
        introduction: "",
        techUID: "",
        techName: "",
        sceneUID: "",
        sceneName: "",
        UserName: "",
        UserNameEmail: "",
        UserId: "",
        UserIDName: [],
        realPlatform: "", //部署平台
        otherPlatform: "", //其他部署平台
        PubState: "",
        empVersion: "", //数字员工版本
        ManSingleTime: "",
        ManFrequency: "",
        DevelopTime: "",
        RobotSingleTime: "",
        RobotMonthRun: "",
        SingleSaveTime: "",
        otherAppID: "",
        verHistory: "",
        MachineName: "",
        fPathPackage: "",
        fPathPdd: "",
        fPathPhoto: "",
        ExecBegin: "",
        ExecEnd: "",
        isPro: false, //是否生产发布
        difyViewType: "",
        difyViewDivsion: "",
        deployType: "",
        localReason: "",
        localAppPath: "",
        localExeFile: "",
        localExeParam: "",
        localAppType: "", //本地程序类型 1 python 2 exe 3excel 4 其他 5
        operationNodes: 0,
        replaceNodes: 0,
    },
    formRules: {
        reqNo: [{ required: false, message: "需求编号不能为空" }],
        ProcessID: [{ required: true, message: "开发编号不能为空" }],
        ProcessName: [{ required: true, message: "数字员工名称不能为空" }],
        processDesc: [{ required: false, message: "工作场景描述不能为空" }],
        sceneBussValue: [{ required: false, message: "场景业务价值不能为空" }],
        empType: [{ required: true, message: "数字员工类型不能为空" }],
        introduction: [{ required: true, message: "数字员工简介不能为空" }],
        techUID: [{ required: true, message: "辅导老师不能为空" }],
        sceneUID: [{ required: false, message: "场景组担当不能为空" }],
        UserNameEmail: [{ required: true, message: "业务人员不能为空" }],
        PubState: [{ required: true, message: "发布阶段不能为空" }],
        empVersion: [{ required: true, message: "数字员工版本不能为空" }],
        realPlatform: [{ required: true, message: "部署平台不能为空" }],
        otherPlatform: [{ required: false, message: "开发工具或语言不能为空" }],
        ManSingleTime: [
            { required: false, message: "Before-人工每次耗时(分钟)不能为空" },
        ],
        ManFrequency: [
            { required: false, message: "Before-人工每月次数不能为空" },
        ],
        DevelopTime: [{ required: false, message: "开发时长不能为空" }],
        RobotSingleTime: [
            { required: false, message: "After-每次耗时(分钟)不能为空" },
        ],
        RobotMonthRun: [{ required: false, message: "After-每月次数不能为空" }],
        otherAppID: [{ required: false, message: "外部AppID不能为空" }],
        verHistory: [{ required: false, message: "版本变更备注不能为空" }],
        ExecBegin: [{ required: false, message: "定时执行开始时间不能为空" }],
        ExecEnd: [{ required: false, message: "定时执行结束时间不能为空" }],
        fPathPackage: [{ required: true, message: "程序包不能为空" }],
        fPathPdd: [{ required: true, message: "设计文档不能为空" }],
        fPathPhoto: [{ required: false, message: "数字员工照片不能为空" }],
        difyViewType: [
            { required: false, message: "Dify员工公开范围不能为空" },
        ],
        difyViewDivsion: [{ required: false, message: "公开总部不能为空" }],
        deployType: [{ required: true, message: "运行方式不能为空" }],
        localReason: [{ required: false, message: "本地运行原因不能为空" }],
        localAppPath: [
            { required: false, message: "本地应用程序路径不能为空" },
        ],
        localExeFile: [{ required: false, message: "本地可执行文件不能为空" }],
        localExeParam: [
            { required: false, message: "本地可执行文件参数不能为空" },
        ],
        localAppType: [{ required: false, message: "本地程序类型不能为空" }],
        operationNodes: [{ required: false, message: "操作节点数不能为空" }],
        replaceNodes: [{ required: false, message: "替代节点数不能为空" }],
    },
});
let dtUser = ref(null);
let iShowSelectUser = ref(false);
let onePackageFile = ref({}); //上传的附件
let isShowPackageLink = ref(false);
let onePDDFile = ref({}); //上传的附件
let isShowPDDLink = ref(false);
let onePhotoFile = ref({}); //上传的附件
let oneAppFile = ref({}); //上传的附件
let oneExeFile = ref({}); //上传的附件
let isShowPhotoLink = ref(false);
let isShowRequireSel = ref(false); //发布申请，选择需求
let submitting = ref(false);
let isViewFooter = ref(true);
let editType = ref("1"); //1新增 2编辑 3 管理员编辑
const rForm = ref(null);
let isDifyDE = ref(false);
let dtReqs = ref([]); //需求列表
let isShowDeployType = ref(false); //是否显示运行方式
let isShowLocalExeFile = ref(false); //是否显示本地执行文件
let isShowLocalExeParam = ref(false); //是否显示本地执行参数
let isShowLocalAppPath = ref(false); //是否显示本地应用程序路径
let isFirstLoad = ref(false); //是否首次加载
const emit = defineEmits(["flashPubList"]);
const reqTablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
    searchKey: "",
});
let otherPlatformLabel = ref("开发工具或语言");
let localAppPathLabel = ref("Python.exe路径");
let localExeFileLabel = ref("Python文件");
let localExeParamLabel = ref("程序执行参数");
let localAppPlaceholder = ref("Python.exe 路径(如：C:\\Python\\python.exe)");
let localFilePlaceholder = ref("Python脚本 路径(如：C:\\Python\\script.py)");
const localAppTypeOptions = [
    {
        value: "1",
        label: "Python程序文件(.py)",
        tip: "",
    },
    {
        value: "2",
        label: "可执行文件(.exe)",
        tip: "",
    },
    {
        value: "3",
        label: "Excel宏(.xlsm、VBA等)",
        tip: "",
    },
    {
        value: "5",
        label: "其他编程语言",
        tip: "如 MATLAB、PLC、Android、TypeScript、VBS、.Net、Java等，请在【开发工具或语言】描述技术实现方式",
    },
    {
        value: "6",
        label: "咚咚应用",
        tip: "如咚咚AI表格、AI助理、咚咚OA审批流、Deap平台等，请在【外部AppID】填写访问链接",
    },
    {
        value: "7",
        label: "智能体",
        tip: "使用AI应用开发平台（如Coze、友答、AI Works、悟空等）创建的工作流、智能体、聊天助手等应用，请在【外部AppID】填写访问链接",
    },
    {
        value: "8",
        label: "其他业务系统",
        tip: "业务自主建设的应用系统（如网站、后台服务）等，请在【外部AppID】填写访问链接",
    },
    {
        value: "4",
        label: "其他",
        tip: "未在上述选项中，请在【开发工具或语言】描述技术实现方式",
    },
];
const getLocalAppTypeTip = (value) => {
    const option = localAppTypeOptions.find(
        (item) => item.value === String(value)
    );

    return option?.tip || "";
};
const findUserData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: userTablePager.currentPage,
        pageSize: userTablePager.pageSize,
        searchKey: [userTablePager.searchKey],
    };
    proxy.$api.systemManageAPI
        .getUserList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            dtUser.value = res.data.Data.dataTable;
            userTablePager.currentPage = res.data.Data.currentPage;
            userTablePager.pageSize = res.data.Data.pageSize;
            userTablePager.totalResult = res.data.Data.totalResult;
        })
        .catch((error) => {
            console.log(error);
        });
};
const findReqsData = () => {
    const findStat = "5"; //已审核
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: reqTablePager.currentPage,
        pageSize: reqTablePager.pageSize,
        searchKey: [reqTablePager.searchKey, "1", findStat], //第1个参数，是按创建人查询
    };
    proxy.$api.newRequireManageAPI
        .getRequireList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });

                return;
            }
            // console.log(res.data.Data);
            dtReqs.value = res.data.Data.dataTable;
            reqTablePager.currentPage = res.data.Data.currentPage;
            reqTablePager.pageSize = res.data.Data.pageSize;
            reqTablePager.totalResult = res.data.Data.totalResult;
        })
        .catch((error) => {
            console.log(error);
        });
};
const updateSingleSaveTime = () => {
    formInput.formData.SingleSaveTime =
        formInput.formData.ManSingleTime - formInput.formData.RobotSingleTime;
};
const userListPageChange = () => {
    findUserData();
};
const reqListPageChange = () => {
    findReqsData();
};
const getTechName = () => {
    const selected = formInput.allTechs?.find(
        (t) => t.value === formInput.formData.techUID
    );
    return selected ? selected.label : "";
};
const getSceneName = () => {
    const selected = formInput.allScenes?.find(
        (t) => t.value === formInput.formData.sceneUID
    );
    return selected ? selected.label : "";
};
const closeWinEvent = () => {
    emit("flashPubList");
};
//新增
const addPublish = async () => {
    formInput.formData = {
        Id: proxy.$utils.guid(),
        empNo: "",
        AuditStatus: "0",
        reqNo: "", //需求编号
        ProcessName: "",
        ProcessID: "",
        processDesc: "",
        sceneBussValue: "",
        CreateMan: proxy.$store.state.Id,
        CreateManName: proxy.$store.state.userName,
        division: proxy.$store.state.jobZb,
        DevelopUser: proxy.$store.state.userName,
        DevelopUserUID: proxy.$store.state.Id,
        empType: "",
        introduction: "",
        techUID: "",
        techName: "",
        sceneUID: formInput.sceneUID,
        sceneName: "",
        UserName: "",
        UserNameEmail: "",
        UserId: "",
        UserIDName: [],
        realPlatform: "", //部署平台
        otherPlatform: "", //其他部署平台
        PubState: "",
        empVersion: "V1.0", //数字员工版本
        ManSingleTime: "",
        ManFrequency: "",
        DevelopTime: "",
        RobotSingleTime: "",
        RobotMonthRun: "",
        SingleSaveTime: "",
        MachineName: "",
        otherAppID: "",
        verHistory: "",
        fPathPackage: "",
        fPathPdd: "",
        fPathPhoto: "",
        isPro: false, //是否生产发布
        difyViewType: "",
        difyViewDivsion: "",
        ExecBegin: "",
        ExecEnd: "",
        localAppType: "",
        localAppPath: "",
        localExeFile: "",
        localExeParam: "",
        operationNodes: 0,
        replaceNodes: 0,
    };
    editType.value = "1"; //新增
    formInput.processIDReadonly = true;
    formInput.isShow = true;
    onePhotoFile.value = {};
    onePDDFile.value = {};
    onePackageFile.value = {};
    submitting.value = false;
    isShowPackageLink.value = false;
    isShowPDDLink.value = false;
    isShowPhotoLink.value = false;
    isShowDeployType.value = false;
    isShowLocalExeFile.value = false;
    isShowLocalExeParam.value = false;
    formInput.formRules.fPathPhoto[0].required = false;
    formInput.formRules.ManSingleTime[0].required = false;
    formInput.formRules.ManFrequency[0].required = false;
    formInput.formRules.DevelopTime[0].required = false;
    formInput.formRules.RobotSingleTime[0].required = false;
    formInput.formRules.RobotMonthRun[0].required = false;
    formInput.formRules.fPathPackage[0].required = false;
    formInput.formRules.fPathPdd[0].required = false;
    formInput.formRules.fPathPhoto[0].required = false;
    formInput.formRules.ExecBegin[0].required = false;
    formInput.formRules.ExecEnd[0].required = false;
    formInput.allInputDisable = false;
    formInput.saveButDisable = false;
    formInput.formData.isPro = false;
    isViewFooter.value = true;
    formInput.title = "新增上岗申请";
    const $rForm = rForm.value;
    try {
        if ($rForm) {
            await $rForm.reset();
        }
        // const re = await $rForm.clearValidate();
    } catch (e) {
        console.log(e);
    }
};

//选择用户 type 1 开发人员 2 业务人员
const selectUser = (type) => {
    formInput.userSelType = type;
    findUserData();
    iShowSelectUser.value = true;
};
const selectReqs = () => {
    findReqsData();
    isShowRequireSel.value = true;
};

const addPackageQueue = (publishid) => {
    //插入包更新队列
    const params = {
        Id: "",
        Priority: 1,
        PubId: publishid,
        HandleType: 1, //0首次 1 更新包
        Status: 0, // 待处理
        StartTime: "",
        EndTime: "",
        Creator: proxy.$store.state.userID,
        CreationTime: "",
        ErrorMsg: "",
        ExtraMsg: "",
    };
    proxy.$api.newPublishManageAPI
        .addPackageQueue(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const updatePackagePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
});
const findPackageData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: updatePackagePager.currentPage,
        pageSize: updatePackagePager.pageSize,
        searchKey: [packageForm.selPublishId],
    };
    proxy.$api.newPublishManageAPI
        .getPackageList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            packageForm.dtPackage = res.data.Data.dataTable;
            updatePackagePager.currentPage = res.data.Data.currentPage;
            updatePackagePager.pageSize = res.data.Data.pageSize;
            updatePackagePager.totalResult = res.data.Data.totalResult;
        })
        .catch((error) => {
            console.log(error);
        });
};

const confirmSelectUser = () => {
    iShowSelectUser.value = false;
};
const xTableReqs = ref(null);
const confirmSelectReq = () => {
    const $table = xTableReqs.value;
    const record = $table.getCurrentRecord();
    if (!record) {
        VXETable.modal.message({ content: "请选择一行数据", status: "info" });
        return;
    }
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 20,
        searchKey: [record.Id],
    };
    proxy.$api.requireManageAPI
        .getRequireOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            let oneModel = res.data.Data.dataTable[0];
            formInput.formData.ProcessName = oneModel.processName;
            formInput.formData.ProcessID = oneModel.processID;
            formInput.formData.reqNo = oneModel.requireNo;
            formInput.formData.sceneBussValue = oneModel.sceneBussValue;
            formInput.formData.processDesc = oneModel.processDesc;
            formInput.formData.techUID = oneModel.tutorUID;
            formInput.formData.techName = oneModel.tutorName;
            formInput.formData.realPlatform = oneModel.planPlatform;
            formInput.formData.otherPlatform = oneModel.otherPlatform ?? "";
            if (formInput.formData.realPlatform == "PT003") {
                formInput.formData.empType = "L02";
            } else {
                formInput.formData.empType = "L01";
            }
            // 默认业务就是需求申请人

            formInput.formData.UserNameEmail =
                oneModel.bussName + "(" + oneModel.bussEmail + ")";

            // 查询用户ID
            const params = {
                uid: proxy.$store.state.userID,
                email: proxy.$store.state.email,
                currentPage: 0,
                pageSize: 1,
                searchKey: [oneModel.bussEmail],
            };
            proxy.$api.systemManageAPI
                .getUserList(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    // console.log(res.data.Data);
                    let userId = res.data.Data.dataTable[0].Id;

                    formInput.formData.UserId = userId;

                    formInput.formData.UserIDName = [];

                    formInput.formData.UserIDName.push({
                        Name: formInput.formData.UserNameEmail.toString(),
                        ID: formInput.formData.UserId.toString(),
                    });
                })
                .catch((error) => {
                    console.log(error);
                });

            onSelectPubState();
        })
        .catch((error) => {
            console.log(error);
        });
    isShowRequireSel.value = false;
};
//删除用户
const clearUser = (userid) => {
    let idx = -1;
    formInput.formData.UserIDName.forEach(function (item, index, arr) {
        if (item.ID == userid) {
            idx = index;
        }
    });
    let tmpId = [],
        tmpname = [];
    tmpId = formInput.formData.UserId.toString().split(";");
    tmpname = formInput.formData.UserNameEmail.toString().split(";");
    tmpId.splice(idx, 1);
    tmpname.splice(idx, 1);
    formInput.formData.UserId = tmpId.join(";");
    formInput.formData.UserNameEmail = tmpname.join(";");
    let count = 0;
    if (formInput.formData.UserId.toString() != "") {
        count = formInput.formData.UserId.toString().split(";").length;
    }
    formInput.formData.UserIDName = [];
    //debugger
    for (let i = 0; i < count; i++) {
        formInput.formData.UserIDName.push({
            Name: formInput.formData.UserNameEmail.toString().split(";")[i],
            ID: formInput.formData.UserId.toString().split(";")[i],
        });
    }
};

const xTableUser = ref(null);

//选择用户
const chooseUser = () => {
    const $table = xTableUser.value;

    const record = $table.getCurrentRecord();

    if (!record) {
        VXETable.modal.message({ content: "请选择一行数据", status: "info" });
        return;
    }

    //选开发人员
    if (formInput.userSelType === 1) {
        formInput.formData.DevelopUser =
            record.UserName + "(" + record.UserMail + ")";
        formInput.formData.DevelopUserUID = record.Id;
        formInput.formData.DevelopIDName = [];
        formInput.formData.DevelopIDName.push({
            Name: formInput.formData.DevelopUser,
            ID: formInput.formData.DevelopUserUID,
        });

        formInput.formData.CreateMan = record.Id;
        formInput.formData.CreateManName = record.UserName;
        formInput.formData.division = record.JobZb;

        //选业务人员
    } else if (formInput.userSelType === 2) {
        //判断是否已选择过
        if (formInput.formData.UserId.toString() != "") {
            for (let item of formInput.formData.UserId.toString().split(";")) {
                if (item == record.Id) {
                    VXETable.modal.message({
                        content: "该人员已选择",
                        status: "warning",
                    });
                    return;
                }
            }
        }

        if (
            formInput.formData.UserNameEmail == null ||
            formInput.formData.UserNameEmail == ""
        ) {
            formInput.formData.UserNameEmail =
                record.UserName + "(" + record.UserMail + ")";
        } else {
            formInput.formData.UserNameEmail +=
                ";" + record.UserName + "(" + record.UserMail + ")";
        }

        if (
            formInput.formData.UserId == null ||
            formInput.formData.UserId == ""
        ) {
            formInput.formData.UserId = record.Id;
        } else {
            formInput.formData.UserId += ";" + record.Id;
        }

        let count = formInput.formData.UserId.toString().split(";").length;

        formInput.formData.UserIDName = [];

        for (let i = 0; i < count; i++) {
            formInput.formData.UserIDName.push({
                Name: formInput.formData.UserNameEmail.toString().split(";")[i],
                ID: formInput.formData.UserId.toString().split(";")[i],
            });
        }
    }
};
const getModel = () => {
    const data = new FormData();
    data.append("filePackage", onePackageFile.value);
    data.append("filePdd", onePDDFile.value);
    data.append("filePhoto", onePhotoFile.value);
    data.append("Id", formInput.formData.Id);
    data.append("fPathPackage", formInput.formData.fPathPackage);
    data.append("fPathPdd", formInput.formData.fPathPdd);
    data.append("fPathPhoto", formInput.formData.fPathPhoto);
    data.append("reqNo", formInput.formData.reqNo);
    data.append("ProcessName", formInput.formData.ProcessName);
    data.append("ProcessID", formInput.formData.ProcessID);
    data.append("processDesc", formInput.formData.processDesc);
    data.append("sceneBussValue", formInput.formData.sceneBussValue);
    data.append("CreateMan", formInput.formData.CreateMan);
    data.append("division", formInput.formData.division);
    data.append("AuditStatus", formInput.formData.AuditStatus);
    data.append("UserId", formInput.formData.UserId);
    data.append("PubState", formInput.formData.PubState);
    data.append("empType", formInput.formData.empType);
    data.append("introduction", formInput.formData.introduction);
    data.append("techUID", formInput.formData.techUID);
    data.append("techName", getTechName());
    data.append("sceneUID", formInput.formData.sceneUID);
    data.append("sceneName", getSceneName());
    data.append("ManSingleTime", formInput.formData.ManSingleTime);
    data.append("ManFrequency", formInput.formData.ManFrequency);
    data.append("DevelopTime", formInput.formData.DevelopTime);
    data.append("RobotSingleTime", formInput.formData.RobotSingleTime);
    data.append("RobotMonthRun", formInput.formData.RobotMonthRun);
    data.append("createUserId", formInput.formData.CreateMan);
    data.append("MachineName", formInput.formData.MachineName);
    data.append("realPlatform", formInput.formData.realPlatform);
    data.append("otherPlatform", formInput.formData.otherPlatform);
    data.append("empVersion", formInput.formData.empVersion);
    data.append("SingleSaveTime", formInput.formData.SingleSaveTime);
    data.append("otherAppID", formInput.formData.otherAppID);
    data.append("verHistory", formInput.formData.verHistory);
    data.append("DevelopUser", formInput.formData.DevelopUser);
    data.append("DevelopUserUID", formInput.formData.DevelopUserUID);
    data.append("difyViewType", formInput.formData.difyViewType);
    data.append("difyViewDivsion", formInput.formData.difyViewDivsion);
    data.append("empNo", formInput.formData.empNo);
    data.append("ExecBegin", formInput.formData.ExecBegin);
    data.append("ExecEnd", formInput.formData.ExecEnd);
    data.append("deployType", formInput.formData.deployType);
    data.append("localReason", formInput.formData.localReason);
    data.append("localAppType", formInput.formData.localAppType);
    data.append("localAppPath", formInput.formData.localAppPath);
    data.append("localExeFile", formInput.formData.localExeFile);
    data.append("localExeParam", formInput.formData.localExeParam);
    data.append("operationNodes", formInput.formData.operationNodes);
    data.append("replaceNodes", formInput.formData.replaceNodes);
    return data;
};
//保存流程
const save = async () => {
    const $rForm = rForm.value;
    const formErrMap = await $rForm.validate();
    if (formErrMap) {
        return;
    }
    // 派神易，uipath,python 才校验
    if (
        !isShowPackageLink.value &&
        ["PT001", "PT002", "PT005"].includes(formInput.formData.realPlatform)
    ) {
        if (formInput.formData.fPathPackage === "") {
            await VXETable.modal.message({
                content: "程序包不能为空",
                status: "warning",
            });
            return;
        }
        if (!isShowPDDLink.value && formInput.formData.fPathPdd === "") {
            await VXETable.modal.message({
                content: "设计文档不能为空",
                status: "warning",
            });
            return;
        }
    }
    if (
        ["PT004", "PT006"].includes(formInput.formData.realPlatform) &&
        formInput.formData.deployType === "平台"
    ) {
        await VXETable.modal.message({
            content: "OutSystem和其他部署平台，运行方式不能选平台",
            status: "warning",
        });
        return;
    }

    //1、校验：运行方式选择本地部署时，发布阶段必须为生产发布
    if (
        formInput.formData.deployType === "本地" &&
        formInput.formData.PubState !== "2"
    ) {
        await VXETable.modal.message({
            content: "运行方式选择本地部署时，发布阶段必须为生产发布",
            status: "warning",
        });
        return;
    }

    //2、校验：发布阶段为生产发布时，设计文档为必填项
    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.fPathPdd === ""
    ) {
        await VXETable.modal.message({
            content: "发布阶段为生产发布时，设计文档不能为空",
            status: "warning",
        });
        return;
    }

    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.ManSingleTime <= 0
    ) {
        VXETable.modal.message({
            content: "Before-人工每次耗时(分钟)必须大于0 ",
            status: "warning",
        });
        return;
    }
    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.ManFrequency <= 0
    ) {
        VXETable.modal.message({
            content: "Before-人工每月次数必须大于0 ",
            status: "warning",
        });
        return;
    }
    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.RobotSingleTime <= 0
    ) {
        VXETable.modal.message({
            content: "After-每次耗时(分钟)必须大于0",
            status: "warning",
        });
        return;
    }
    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.RobotMonthRun <= 0
    ) {
        VXETable.modal.message({
            content: "After-每月次数必须大于0 ",
            status: "warning",
        });
        return;
    }
    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.DevelopTime <= 0
    ) {
        VXETable.modal.message({
            content: "开发时长必须大于0",
            status: "warning",
        });
        return;
    }
    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.operationNodes <= 0
    ) {
        VXETable.modal.message({
            content: "总任务节点数必须大于0",
            status: "warning",
        });
        return;
    }
    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.replaceNodes <= 0
    ) {
        VXETable.modal.message({
            content: "数字员工替代节点数必须大于0",
            status: "warning",
        });
        return;
    }
    const data = getModel();
    submitting.value = true;
    //新增
    if (editType.value === "1") {
        proxy.$api.newPublishManageAPI
            .addPublish(data)
            .then((res) => {
                if (res.data.Success == false) {
                    submitting.value = false;
                    VXETable.modal.alert({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                editType.value = "2"; //新增后是修改
                checkHasFiles();
                formInput.formRules.fPathPackage[0].required = false;
                formInput.formRules.fPathPdd[0].required = false;
                formInput.formRules.fPathPhoto[0].required = false;
                submitting.value = false;
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
            })
            .catch((error) => {
                submitting.value = false;
                VXETable.modal.alert({ content: error, status: "error" });
                console.log(error);
            });
    } else if (editType.value === "2") {
        //更新
        proxy.$api.newPublishManageAPI
            .updatePublish(data)
            .then((res) => {
                if (res.data.Success == false) {
                    submitting.value = false;
                    VXETable.modal.alert({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                checkHasFiles();

                formInput.formRules.fPathPackage[0].required = false;
                formInput.formRules.fPathPdd[0].required = false;
                formInput.formRules.fPathPhoto[0].required = false;
                editType.value = "2"; //
                submitting.value = false;
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
            })
            .catch((error) => {
                submitting.value = false;
                VXETable.modal.message({ content: error, status: "error" });
                console.log(error);
            });
    } else if (editType.value === "3") {
        //管理员修改
        proxy.$api.newPublishManageAPI
            .updateAdminPublish(data)
            .then((res) => {
                if (res.data.Success == false) {
                    submitting.value = false;
                    VXETable.modal.alert({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                checkHasFiles();
                formInput.formRules.fPathPackage[0].required = false;
                formInput.formRules.fPathPdd[0].required = false;
                formInput.formRules.fPathPhoto[0].required = false;
                editType.value = "3"; //
                submitting.value = false;
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
            })
            .catch((error) => {
                submitting.value = false;
                VXETable.modal.message({ content: error, status: "error" });
                console.log(error);
            });
    }
};
//type:1 部署平台选择 2 发布阶段选择
const onSelectPubState = (type = "1") => {
    //测试发布
    if (formInput.formData.PubState === "1") {
        formInput.formData.isPro = false;
        if (editType.value == "1" || type === "2") {
            //新增时校验
            //派神易 uipath python
            if (
                ["PT001", "PT002", "PT005"].includes(
                    formInput.formData.realPlatform
                )
            ) {
                formInput.formRules.fPathPackage[0].required = true;
                formInput.formRules.fPathPdd[0].required = true;
            } else {
                formInput.formRules.fPathPackage[0].required = false;
                formInput.formRules.fPathPdd[0].required = false;
            }
        }

        formInput.formRules.fPathPhoto[0].required = false;
        formInput.formRules.ManSingleTime[0].required = false;
        formInput.formRules.ManFrequency[0].required = false;
        formInput.formRules.DevelopTime[0].required = false;
        formInput.formRules.RobotSingleTime[0].required = false;
        formInput.formRules.RobotMonthRun[0].required = false;
        formInput.formRules.ExecBegin[0].required = false;
        formInput.formRules.ExecEnd[0].required = false;
        formInput.formRules.operationNodes[0].required = false;
        formInput.formRules.replaceNodes[0].required = false;
        formInput.formData.ManSingleTime = 0;
        formInput.formData.ManFrequency = 0;
        formInput.formData.DevelopTime = 0;
        formInput.formData.RobotSingleTime = 0;
        formInput.formData.RobotMonthRun = 0;
        formInput.formData.ExecBegin = "";
        formInput.formData.ExecBegin = "";

        // 生产发布
    } else if (formInput.formData.PubState === "2") {
        formInput.formData.isPro = true;

        if (editType.value == "1" || type === "2") {
            if (
                ["PT001", "PT002", "PT005"].includes(
                    formInput.formData.realPlatform
                )
            ) {
                formInput.formRules.fPathPhoto[0].required = false;
                formInput.formRules.fPathPackage[0].required = true;
            } else {
                formInput.formRules.fPathPhoto[0].required = false;
                formInput.formRules.fPathPackage[0].required = false;
            }
            formInput.formRules.fPathPdd[0].required = true;
        }

        formInput.formRules.ManSingleTime[0].required = true;
        formInput.formRules.ManFrequency[0].required = true;
        formInput.formRules.DevelopTime[0].required = true;
        formInput.formRules.RobotSingleTime[0].required = true;
        formInput.formRules.RobotMonthRun[0].required = true;
        formInput.formRules.ExecBegin[0].required = false;
        formInput.formRules.ExecEnd[0].required = false;
        formInput.formRules.operationNodes[0].required = true;
        formInput.formRules.replaceNodes[0].required = true;
    }
    //部署平台选择 PT003 Dify  PT004 outsystem  PT006 其他平台
    formInput.formRules.otherPlatform[0].required = [
        "PT003",
        "PT004",
        "PT006",
    ].includes(formInput.formData.realPlatform);

    //选Dify就填外部APPID
    formInput.formRules.otherAppID[0].required =
        formInput.formData.realPlatform === "PT003";

    if (formInput.formData.realPlatform === "PT003") {
        otherPlatformLabel.value = "Dify链接";
        formInput.formRules.otherPlatform[0].message = "Dify链接不能为空";
    } else if (formInput.formData.realPlatform === "PT004") {
        otherPlatformLabel.value = "Outsystem链接";
        formInput.formRules.otherPlatform[0].message = "Outsystem链接不能为空";
    } else {
        otherPlatformLabel.value = "开发工具或语言";
        formInput.formRules.otherPlatform[0].message = "开发工具或语言不能为空";
    }

    isDifyDE.value = formInput.formData.realPlatform === "PT003";
    formInput.formRules.difyViewType[0].required =
        formInput.formData.realPlatform === "PT003";
    formInput.formRules.difyViewDivsion[0].required =
        formInput.formData.difyViewType === "2";

    //首次加载 或者 发布阶段选择 不触发
    if (isFirstLoad.value || type === "2") {
        return;
    }
    let deployPlatformState = ["PT001", "PT002", "PT003", "PT005"];
    if (deployPlatformState.includes(formInput.formData.realPlatform)) {
        formInput.formData.deployType = "平台";
    } else {
        formInput.formData.deployType = "本地";
    }
    // 平台还是本地
    onSelectDeployType();
};

const onSelectDeployType = () => {
    //平台运行
    if (formInput.formData.deployType === "平台") {
        formInput.formRules.localReason[0].required = false;
        formInput.formRules.localAppType[0].required = false;
        formInput.formData.localReason = "";
        isShowDeployType.value = false;
    } else if (formInput.formData.deployType === "本地") {
        formInput.formRules.localReason[0].required = true;
        formInput.formRules.localAppType[0].required = true;
        isShowDeployType.value = true;
    }
    // python exe excel
    onSelectLocalAppType();
};

const onSelectLocalAppType = () => {
    if (formInput.formData.localAppType === "1") {
        localAppPathLabel.value = "Python.exe路径";
        localExeFileLabel.value = "Python文件";
        localExeParamLabel.value = "程序执行参数";
        localAppPlaceholder.value =
            "Python.exe 路径(如：C:\\Python\\python.exe)";
        localFilePlaceholder.value =
            "Python脚本 路径(如：C:\\Python\\script.py)";
        isShowLocalExeFile.value = true;
        isShowLocalExeParam.value = true;
        isShowLocalAppPath.value = true;
        formInput.formRules.localAppPath[0].required = true;
        formInput.formRules.localAppPath[0].message =
            "请输入Python.exe程序路径";
        formInput.formRules.localExeFile[0].required = true;
        formInput.formRules.localExeFile[0].message = "请输入Python文件路径";
    } else if (formInput.formData.localAppType === "2") {
        //Exe
        localAppPathLabel.value = "Exe程序路径";
        localExeFileLabel.value = "Exe程序路径";
        localExeParamLabel.value = "程序执行参数";
        localAppPlaceholder.value =
            "Exe程序路径(如：C:\\Program Files\\MyApp\\app.exe)";
        localFilePlaceholder.value =
            "Exe程序路径(如：C:\\Program Files\\MyApp\\app.exe)";
        formInput.formData.localExeFile = "";
        isShowLocalExeFile.value = false;
        isShowLocalExeParam.value = true;
        isShowLocalAppPath.value = true;
        formInput.formRules.localAppPath[0].required = true;
        formInput.formRules.localAppPath[0].message = "请输入Exe程序路径";
        formInput.formRules.localExeFile[0].required = false;
        formInput.formRules.localExeFile[0].message = "请输入Exe程序路径";
    } else if (formInput.formData.localAppType === "3") {
        //Excel
        localAppPathLabel.value = "Excel程序路径";
        localExeFileLabel.value = "Excel文件";
        localExeParamLabel.value = "Excel参数";
        localAppPlaceholder.value =
            "Excel程序路径(如：C:\\Program Files\\MyApp\\Excel.exe)";
        localFilePlaceholder.value =
            "Excel文件路径(如：C:\\Program Files\\MyApp\\file.xlsx)";
        formInput.formData.localExeParam = "";
        isShowLocalExeFile.value = true;
        isShowLocalExeParam.value = false;
        isShowLocalAppPath.value = true;
        formInput.formRules.localAppPath[0].required = true;
        formInput.formRules.localAppPath[0].message = "请输入Excel.exe程序路径";
        formInput.formRules.localExeFile[0].required = true;
        formInput.formRules.localExeFile[0].message = "请输入Excel文件路径";
    } else {
        //其他
        localAppPathLabel.value = "程序路径";
        localExeFileLabel.value = "文件路径";
        localExeParamLabel.value = "执行参数";
        localAppPlaceholder.value =
            "程序路径(如：C:\\Program Files\\MyApp\\app.exe)";
        localFilePlaceholder.value =
            "文件路径(如：C:\\Program Files\\MyApp\\file.exe)";
        formInput.formData.localExeParam = "";
        isShowLocalExeFile.value = false;
        isShowLocalExeParam.value = false;
        isShowLocalAppPath.value = false;
        formInput.formRules.localAppPath[0].required = false;
        formInput.formRules.localExeFile[0].required = false;
    }
    if (formInput.formData.deployType === "本地") {
        if (
            formInput.formData.localAppType === "5" ||
            formInput.formData.localAppType === "4"
        ) {
            formInput.formRules.otherPlatform[0].required = true;
            formInput.formRules.otherAppID[0].required = false;
        } else if (formInput.formData.localAppType === "6") {
            formInput.formRules.otherAppID[0].required = true;
            formInput.formRules.otherPlatform[0].required = false;
        } else if (formInput.formData.localAppType === "7") {
            formInput.formRules.otherAppID[0].required = true;
            formInput.formRules.otherPlatform[0].required = false;
        } else if (formInput.formData.localAppType === "8") {
            formInput.formRules.otherAppID[0].required = true;
            formInput.formRules.otherPlatform[0].required = false;
        } else {
            formInput.formRules.otherPlatform[0].required = false;
            formInput.formRules.otherAppID[0].required = false;
        }
    } else {
        formInput.formRules.otherPlatform[0].required = false;
        formInput.formRules.otherAppID[0].required = false;
    }
};

const onDifyViewTypeChange = () => {
    formInput.formRules.difyViewDivsion[0].required =
        formInput.formData.difyViewType === "2";
};
const insertPackageEvent = async () => {
    const { files } = await VXETable.readFile(false);
    Array.from(files).map((file) => {
        formInput.formData.fPathPackage = file.name;
        onePackageFile.value = file;
    });
};
//浏览本地应用路径
const insertLocalAppPath = async () => {
    const { files } = await VXETable.readFile(false);
    Array.from(files).map((file) => {
        formInput.formData.localAppPath = file.name;
        oneAppFile.value = file;
    });
};
//浏览本地可执行文件
const insertLocalExeFile = async () => {
    const { files } = await VXETable.readFile(false);
    Array.from(files).map((file) => {
        formInput.formData.localExeFile = file.name;
        oneExeFile.value = file;
    });
};
const insertPDDEvent = async () => {
    const { files } = await VXETable.readFile(false);
    Array.from(files).map((file) => {
        formInput.formData.fPathPdd = file.name;
        onePDDFile.value = file;
    });
};
const insertPhotoEvent = async () => {
    const { files } = await VXETable.readFile(false);
    Array.from(files).map((file) => {
        formInput.formData.fPathPhoto = file.name;
        onePhotoFile.value = file;
    });
};

const downloadFile = (type) => {
    proxy.$api.fileManageAPI
        .downloadPublishFile(
            Qs.stringify({
                publishId: formInput.formData.Id,
                type: type,
            }),
            {
                responseType: "blob",
            }
        )
        .then((res) => {
            const contentType = res.headers["content-type"] || "";

            // 如果后端返回的是 JSON，说明是错误信息
            if (contentType.includes("application/json")) {
                const reader = new FileReader();

                reader.onload = () => {
                    try {
                        const result = JSON.parse(reader.result);

                        VXETable.modal.alert({
                            content:
                                result.Message || result.message || "下载失败",
                            status: "error",
                        });
                    } catch (e) {
                        VXETable.modal.alert({
                            content: "下载失败",
                            status: "error",
                        });
                    }
                };

                reader.readAsText(res.data);
                return;
            }

            let fileName = "下载文件";

            const disposition =
                res.headers["content-disposition"] ||
                res.headers["Content-Disposition"];

            if (disposition) {
                const utf8Match = disposition.match(
                    /filename\*=UTF-8''([^;]+)/i
                );
                const normalMatch = disposition.match(/filename="?([^"]+)"?/i);

                if (utf8Match && utf8Match[1]) {
                    fileName = decodeURIComponent(utf8Match[1]);
                } else if (normalMatch && normalMatch[1]) {
                    fileName = decodeURIComponent(normalMatch[1]);
                }
            }

            const blob = new Blob([res.data], {
                type: contentType || "application/octet-stream",
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;
            link.style.display = "none";

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            console.log(error);

            VXETable.modal.alert({
                content: "文件下载失败",
                status: "error",
            });
        });
};
const checkHasFiles = () => {
    proxy.$api.newPublishManageAPI
        .checkPublishHasFiles(
            Qs.stringify({
                publishId: formInput.formData.Id,
                type: "",
            })
        )
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.alert({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            let fileStatus = res.data.Data.split(",");

            isShowPackageLink.value = fileStatus[0] === "1";
            isShowPDDLink.value = fileStatus[1] === "1";
            isShowPhotoLink.value = fileStatus[2] === "1";
        })
        .catch((error) => {
            console.log(error);
        });
};
const addAuditRecord = (status, type) => {
    let auditBuId = "";
    let auditOpinion = "";
    switch (type) {
        case "1":
            auditBuId = formInput.formData.Id;
            auditOpinion = "";
            break;
    }
    //写审核日志
    const params = {
        auditBuId: auditBuId,
        auditMan: proxy.$store.state.userName,
        auditManUid: proxy.$store.state.userID,
        auditStatus: status, //0发起 1 通过 2 驳回
        auditOpinion: auditOpinion,
        auditNode: "审核发起",
    };
    proxy.$api.requireManageAPI
        .addAuditRecord(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
//提交
const submit = async () => {
    const $rForm = rForm.value;
    const formErrMap = await $rForm.validate();
    if (formErrMap) {
        submitting.value = false;
        return;
    }

    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.ManSingleTime <= 0
    ) {
        VXETable.modal.message({
            content: "Before-人工每次耗时(分钟)必须大于0 ",
            status: "warning",
        });
        return;
    }
    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.ManFrequency <= 0
    ) {
        VXETable.modal.message({
            content: "Before-人工每月次数必须大于0 ",
            status: "warning",
        });
        return;
    }
    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.RobotSingleTime <= 0
    ) {
        VXETable.modal.message({
            content: "After-每次耗时(分钟)必须大于0",
            status: "warning",
        });
        return;
    }
    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.RobotMonthRun <= 0
    ) {
        VXETable.modal.message({
            content: "After-每月次数必须大于0 ",
            status: "warning",
        });
        return;
    }
    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.DevelopTime <= 0
    ) {
        VXETable.modal.message({
            content: "开发时长必须大于0",
            status: "warning",
        });
        return;
    }
    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.operationNodes <= 0
    ) {
        VXETable.modal.message({
            content: "总任务节点数必须大于0",
            status: "warning",
        });
        return;
    }
    if (
        formInput.formData.PubState === "2" &&
        formInput.formData.replaceNodes <= 0
    ) {
        VXETable.modal.message({
            content: "数字员工替代节点数必须大于0",
            status: "warning",
        });
        return;
    }
    const type = await VXETable.modal.confirm("您确定要提交该数据吗?");

    if (type === "confirm") {
        //如果dify生产发布还要判断执行次数
        if (
            formInput.formData.realPlatform == "PT003" &&
            formInput.formData.PubState == "2"
        ) {
            const params = {
                uid: proxy.$store.state.userID,
                email: proxy.$store.state.email,
                currentPage: 1,
                pageSize: 10,
                searchKey: [formInput.formData.otherAppID],
            };
            try {
                const res =
                    await proxy.$api.newPublishManageAPI.getDifyCheckCount(
                        Qs.stringify(params)
                    );

                if (res.data.Success === false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }

                const checkCount = Number(res.data.Data.checkCount);
                const realCount = Number(res.data.Data.realCount);

                if (checkCount > 0 && realCount < checkCount) {
                    VXETable.modal.message({
                        content: `Dify员工上岗要求先运行${checkCount}次，目前运行${realCount}次，请运行足够次数后再发起上岗`,
                        status: "error",
                    });
                    return;
                }
            } catch (error) {
                console.log(error);
                VXETable.modal.message({
                    content: "请求失败，请稍后重试",
                    status: "error",
                });
                return;
            }
        }

        //1、校验：运行方式选择本地部署时，发布阶段必须为生产发布
        if (
            formInput.formData.deployType === "本地" &&
            formInput.formData.PubState !== "2"
        ) {
            await VXETable.modal.message({
                content: "运行方式选择本地部署时，发布阶段必须为生产发布",
                status: "warning",
            });
            return;
        }

        //2、校验：发布阶段为生产发布时，设计文档为必填项
        if (
            formInput.formData.PubState === "2" &&
            formInput.formData.fPathPdd === ""
        ) {
            await VXETable.modal.message({
                content: "发布阶段为生产发布时，设计文档不能为空",
                status: "warning",
            });
            return;
        }

        const data = getModel();

        submitting.value = true;
        proxy.$api.newPublishManageAPI
            .submitPublish(data)
            .then((res) => {
                if (res.data.Success === false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    submitting.value = false;
                    return;
                }
                VXETable.modal.message({
                    content: "提交成功",
                    status: "success",
                });
                emit("flashPubList");
                addAuditRecord("0", "1"); //写审核日志
                formInput.isShow = false;
                submitting.value = false;
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                submitting.value = false;
                console.log(error);
            });
    }
};
//eventType 1编辑 2管理员编辑
const editRowEvent = (row, eventType) => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 20,
        searchKey: [row.Id],
    };
    proxy.$api.newPublishManageAPI
        .getPublishOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success === false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            isFirstLoad.value = true;
            formInput.formData = res.data.Data;
            formInput.formData.difyViewDivsion =
                res.data.Data.difyViewDivsion.split(",");

            onSelectPubState();
            checkHasFiles();
            onSelectDeployType();
            formInput.formRules.fPathPackage[0].required = false;
            formInput.formRules.fPathPdd[0].required = false;
            formInput.formRules.fPathPhoto[0].required = false;
            if (eventType == "2") {
                //管理员编辑
                editType.value = "3";
                formInput.processIDReadonly = false;
                formInput.title = "管理员编辑上岗申请";
                formInput.allInputDisable = false;
                formInput.saveButDisable = false;
                isViewFooter.value = true;
            } else {
                editType.value = "2"; //更新
                const readonlyStatus = ["1", "2", "5", "6", "7"];
                if (readonlyStatus.includes(formInput.formData.AuditStatus)) {
                    formInput.allInputDisable = true;
                    formInput.saveButDisable = true;
                    formInput.title = "查看上岗申请";
                    isViewFooter.value = false;
                } else {
                    formInput.allInputDisable = false;
                    formInput.saveButDisable = false;
                    formInput.title = "编辑上岗申请";
                    isViewFooter.value = true;
                }
                formInput.processIDReadonly = true;
            }

            const userIds = formInput.formData.UserId.toString().split(";");
            const userNames =
                formInput.formData.UserNameEmail.toString().split(";");
            formInput.formData.UserIDName = userIds.map((id, i) => ({
                Name: userNames[i],
                ID: id,
            }));
            isFirstLoad.value = false;
            formInput.isShow = true;
        })
        .catch((error) => {
            console.log(error);
            VXETable.modal.message({
                content: "请求失败：" + error.message,
                status: "error",
            });
        });
};
const bindHQ = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 50,
        searchKey: [""],
    };
    proxy.$api.digitalDictManageAPI
        .getHeadquarterList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                console.log(res.data.Message);
                return;
            }
            // console.log(res.data.Data);
            formInput.hqOptions = [];
            for (const item of res.data.Data.dataTable) {
                formInput.hqOptions.push({
                    value: item.hqCode,
                    label: item.hqName,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const bindTechMember = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 100,
        searchKey: [""],
    };
    proxy.$api.digitalDictManageAPI
        .getTechMemberList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });

                return;
            }
            formInput.allTechs = [];
            for (const item of res.data.Data.dataTable) {
                formInput.allTechs.push({
                    value: item.uid,
                    label: item.userName,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const bindSceneMember = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 100,
        searchKey: [""],
    };
    proxy.$api.digitalDictManageAPI
        .getSceneMemberList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });

                return;
            }
            formInput.allScenes = [];
            for (const item of res.data.Data.dataTable) {
                formInput.allScenes.push({
                    value: item.uid,
                    label: item.userName,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const bindPlatform = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 100,
        searchKey: [""],
    };
    proxy.$api.digitalDictManageAPI
        .getDeployPlatformList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });

                return;
            }
            formInput.planPlatform = [];
            for (const item of res.data.Data.dataTable) {
                formInput.planPlatform.push({
                    value: item.code,
                    label: item.name,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const bindDigitalType = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 100,
        searchKey: [""],
    };
    proxy.$api.digitalDictManageAPI
        .getDigitalMemberTypeList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            formInput.digitalTypes = [];
            for (const item of res.data.Data.dataTable) {
                formInput.digitalTypes.push({
                    value: item.code,
                    label: item.name,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const bindHeadquarterScene = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 100,
        searchKey: ["", proxy.$store.state.jobZb],
    };
    proxy.$api.digitalDictManageAPI
        .getHeadquarterSceneOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });

                return;
            }
            if (
                Array.isArray(res.data.Data.dataTable) &&
                res.data.Data.dataTable.length > 0
            ) {
                formInput.sceneUID = res.data.Data.dataTable[0].uid;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
// 工具函数3：创建链接按钮
const createLinkButton = (containerId, link, btnText) => {
    const container = document.getElementById(containerId);
    container.innerHTML = "";

    const linkBtn = document.createElement("a");
    linkBtn.href = link;
    linkBtn.className = "btn-link";
    linkBtn.textContent = btnText;

    container.appendChild(linkBtn);
};

function onEmpTypeChange() {
    if (
        formInput.formData.empType == "L02" ||
        formInput.formData.empType == "L03"
    ) {
        VXETable.modal.message({
            content: "助手型与专家型需该数字员工使用了人工智能技术(AI)",
            status: "warning",
        });
    }
}

// 工具函数4：统一生成 BAT
const generateBat = (options) => {
    const {
        protocolName,
        paths = [],
        requiredFields = [],
        params = "",
        containerId,
        useUrlParam = false,
    } = options;

    // 1. 校验
    if (!protocolName || requiredFields.some((v) => !v || !v.trim())) {
        VXETable.modal.message({
            content: "请填写完整的必填项！",
            status: "info",
        });
        return;
    }

    // 2. 格式化路径
    const safeProtocolName = "coe" + protocolName.trim();
    const safePaths = paths.map((p) => formatBatPath(p));

    const baseCommand = safePaths.map((p) => `\\\"${p}\\\"`).join(" ");
    const commandValue = useUrlParam ? baseCommand + ' \\"%%1\\"' : baseCommand;
    const workDir =
        requiredFields.length > 1
            ? requiredFields[1].substring(
                  0,
                  requiredFields[1].lastIndexOf("\\")
              )
            : requiredFields[0].substring(
                  0,
                  requiredFields[0].lastIndexOf("\\")
              );
    // 4. BAT 模板
    const batContent = `@echo off
chcp 65001 >nul 2>&1
title 注册 ${safeProtocolName} 自定义 URL 协议
echo 正在注册 ${safeProtocolName} 协议到 HKEY_CURRENT_USER\\SOFTWARE\\Classes...

reg add "HKCU\\SOFTWARE\\Classes\\${safeProtocolName}" /ve /d "URL:${safeProtocolName} Protocol" /f >nul 2>&1
reg add "HKCU\\SOFTWARE\\Classes\\${safeProtocolName}" /v "URL Protocol" /d "" /f >nul 2>&1
reg add "HKCU\\SOFTWARE\\Classes\\${safeProtocolName}\\shell\\open\\command" /ve /d "cmd.exe /c cd /d \\"${workDir}\\" && ${commandValue}" /f >nul 2>&1
if %errorlevel% equ 0 (
    echo ✅ ${safeProtocolName} 协议注册成功！
) else (
    echo ❌ ${safeProtocolName} 协议注册失败，请检查权限或路径！
)
pause`;

    // 5. 下载
    downloadBatFile(batContent);
};
// 工具函数2：下载BAT文件
const downloadBatFile = (batContent) => {
    try {
        const windowsLineBreakContent = batContent.replace(/\n/g, "\r\n");
        const bom = "\ufeff";
        const finalContent = bom + windowsLineBreakContent;
        const blob = new Blob([finalContent], {
            type: "text/plain; charset=utf-8",
        });

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = formInput.formData.ProcessID + "_register.bat";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        VXETable.modal.message({
            content:
                "注意：\n" +
                "1. 若BAT文件运行出现乱码，请用记事本打开该文件\n" +
                "2. 点击“文件”→“另存为”，编码选择“ANSI”后保存\n" +
                "3. 重新运行保存后的BAT文件即可",
            status: "info",
            duration: 15000, // 10秒（单位：毫秒）
        });
    } catch (e) {
        VXETable.modal.message({
            content: "文件生成失败！",
            status: "error",
        });
    }
};
// 工具函数1：格式化路径
const formatBatPath = (path) => {
    return path.replace(/　/g, " ").trim();
};
const generateBatEntry = () => {
    let options = {
        protocolName: formInput.formData.ProcessID,
        paths:
            formInput.formData.localAppType == "2" //Exe 不用选文件
                ? [formInput.formData.localAppPath]
                : [
                      formInput.formData.localAppPath,
                      formInput.formData.localExeFile,
                  ],
        requiredFields:
            formInput.formData.localAppType == "2"
                ? [formInput.formData.localAppPath]
                : [
                      formInput.formData.localAppPath,
                      formInput.formData.localExeFile,
                  ],
        params: formInput.formData.localExeParam,
        containerId: "pythonLinkBtnContainer",
        useUrlParam: formInput.formData.localExeParam !== "",
    };
    console.log(options);
    generateBat(options);
};

const execLocalFile = () => {
    let safeProtocolName = "coe" + formInput.formData.ProcessID?.trim();
    const params = formInput.formData.localExeParam;
    if (!formInput.formData.ProcessID?.trim()) {
        VXETable.modal.message({
            content: "请输入协议名称！",
            status: "error",
        });
        return;
    }
    const link = isShowLocalExeParam.value
        ? `${safeProtocolName}://${params || ""}`
        : `${safeProtocolName}://`;
    const a = document.createElement("a");
    a.href = link;
    a.click();
};

const viewInstructions = () => {
    const a = document.createElement("a");
    a.href =
        "https://coe.dongfeng-nissan.com.cn/admin/forum/postsPage/postsContent?searcharticle=1677";
    a.target = "_blank";
    a.click();
};

onMounted(() => {
    setTimeout(() => {
        bindHQ();
        bindTechMember();
        bindSceneMember();
        bindHeadquarterScene();
        bindPlatform();
        bindDigitalType();
    }, 10);
});
defineExpose({ addPublish, editRowEvent });
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}

.vxe-select--panel {
    z-index: 2000 !important; /* 比 antd modal / drawer 高 */
}
</style>
